var cardTexts = {
  'sv-SE': {
    ctaButton: 'Välj',
    discount: 'rabatt',
    perPerson: '/person',
    priceDetails: 'Prisdetaljer',
    priceFrom: 'fr. ',
    pricePerPerson: 'Pris per person',
    standard: 'Standard'
  },
  'nb-NO': {
    ctaButton: 'Velg',
    discount: 'rabatt',
    perPerson: 'pr. person',
    priceDetails: 'Prisinformasjon',
    priceFrom: 'fra ',
    pricePerPerson: 'Pris pr. person',
    standard: 'Standard'
  },
  'da-DK': {
    ctaButton: 'Vælg',
    discount: 'i rabat',
    perPerson: 'pr. person',
    priceDetails: 'Prisdetaljer',
    priceFrom: 'fra ',
    pricePerPerson: 'Pris pr. person',
    standard: 'Standard'
  },
  'fi-FI': {
    ctaButton: 'Valitse',
    discount: 'alennus',
    perPerson: '/hlö',
    priceDetails: 'Hintaerittely',
    priceFrom: 'alk. ',
    pricePerPerson: 'Hinta per henkilö',
    standard: 'Luokitus'
  },
  en: {
    ctaButton: 'Choose',
    discount: 'discount',
    perPerson: '/person',
    priceDetails: 'Price details',
    priceFrom: 'from ',
    pricePerPerson: 'Price per person',
    standard: 'Standard'
  }
};
var cardTexts$1 = cardTexts;

export { cardTexts$1 as default };
//# sourceMappingURL=Card.texts.js.map
